import { DialogDescription } from '@radix-ui/react-dialog'
import React from 'react'

interface DescriptionProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode
}

export function Description ({ children, ...props }: DescriptionProps) {
  return (
    <DialogDescription {...props} asChild>
      <div className='body text-gray-800'>{children}</div>
    </DialogDescription>
  )
}

Description.displayName = 'Modal.Description'
